import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'

import { AppEvents } from 'src/constants'

const useAccountPaymentRedirect = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  useEffect(() => {
    const success = searchParams.get('success')
    const cancelled = searchParams.get('cancelled')

    if (success) {
      const detail = { message: 'Your payment has been successful!' }
      const event = new CustomEvent(AppEvents.HTTP_SUCCESS, { detail })
      document.dispatchEvent(event)

      searchParams.delete('success')
    }

    if (cancelled) {
      const detail = { message: 'Your payment has been cancelled' }
      const event = new CustomEvent(AppEvents.HTTP_ERROR, { detail })
      document.dispatchEvent(event)

      searchParams.delete('cancelled')
    }
    setSearchParams(searchParams)
  }, [searchParams, setSearchParams])
}

export { useAccountPaymentRedirect }
